import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, inject } from '@angular/core';

import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';
import { CompetitionLogoComponent } from '@frontend/sports/competition-logos/feature';
import { WidgetTabBarDisplay, WidgetTabBarItem } from '@frontend/sports/widget/feature/tab-bar';
import { DsPill } from '@frontend/ui/pill';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

@Component({
    selector: 'ms-widget-pill',
    templateUrl: './widget-pill.component.html',
    styleUrls: ['./widget-pill.component.scss'],
    imports: [DsPill, ScrollAdapterComponent, CompetitionLogoComponent, CommonModule, IconCustomComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WidgetPillComponent {
    private cdr = inject(ChangeDetectorRef);

    @Input() pills: WidgetTabBarItem[];
    @Output() select = new EventEmitter<WidgetTabBarItem>();
    display = WidgetTabBarDisplay;

    eventSelected(widgetTabBarItem: WidgetTabBarItem): void {
        this.pills.forEach((item) => {
            // eslint-disable-next-line no-param-reassign
            item.active = item.title === widgetTabBarItem.title;
        });
        const tabItem = this.pills.find((e) => e.id === widgetTabBarItem.id);
        this.cdr.markForCheck();
        this.select.emit(tabItem);
    }
}
